import { DesignEntity, Relationship } from '@/lib/enums';
import { getManagedEntitiesForRole } from '../get/managed';

export default function deriveNew(assigned, supported, entity, subject) {
  const plural = DesignEntity.toPlural(entity.__type);
  const proposed = { ...subject };
  proposed.entities = { ...proposed.entities };
  proposed.entities[plural] = { ...proposed.entities[plural] };
  proposed.entities[plural][entity.uuid] = entity;
  // a proposal is not a stored state, so it carries a stamp where a snapshot
  // carries a hash of its content. The clock is coarsened by the browser, so two
  // proposals raised within one tick read as the same state.
  proposed.__hash = performance.now();

  // setup managed
  const managed = {
    [DesignEntity.GROUP]: new Set(),
    [DesignEntity.ROLE]: new Set(),
    [DesignEntity.PERSON]: new Set(),
    [DesignEntity.ACTIVITY]: new Set(),
  };

  for (const id in assigned) {
    if (assigned[id].is_manager) {
      getManagedEntitiesForRole(managed, proposed, id);
    }
  }

  // setup types
  const isGroup = entity.__type === DesignEntity.GROUP;
  const isRole = entity.__type === DesignEntity.ROLE;
  const isActivity = entity.__type === DesignEntity.ACTIVITY;

  // new entity is managed
  if (managed[entity.__type].has(entity.uuid)) {
    return Relationship.MANAGER;
  }

  // new entity is directly assigned role
  if (isRole && Object.hasOwn(assigned, entity.uuid)) {
    return Relationship.ASSIGNEE;
  }

  // new entity is for assigned role
  if (isActivity && Object.hasOwn(assigned, entity.owner_uuid)) {
    return Relationship.ASSIGNEE;
  }

  // directly supported roles
  if (isGroup && supported.has(entity.uuid)) {
    return Relationship.SUPPORTER;
  }

  if (isRole && supported.has(entity.group_uuid)) {
    return Relationship.SUPPORTER;
  }

  if (isActivity && entity.owner_type === DesignEntity.GROUP) {
    return supported.has(entity.owner_uuid)
      ? Relationship.SUPPORTER
      : Relationship.NONE;
  }

  if (isActivity && entity.owner_type === DesignEntity.ROLE) {
    const role = subject.entities.roles[entity.owner_uuid];
    return supported.has(role.group_uuid)
      ? Relationship.SUPPORTER
      : Relationship.NONE;
  }

  return Relationship.NONE;
}
